import {createSlice} from "@reduxjs/toolkit";
import {setUIPipelineFilter} from "./actions";

type PipelineUIState = {
  [key: string]: {
    filter: {
      fromDttm: number,
      toDttm?: number
    }
  }
}

const INITIAL_STATE: Readonly<PipelineUIState> = {};

const pipelineUISlice = createSlice({
  name: "ots-ui/pipeline",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setUIPipelineFilter,
      (state, {payload}) => {
        state[payload.id] = {
          ...(state[payload.id] ?? {}),
          filter: {
            fromDttm: payload.fromDttm,
            toDttm: payload.toDttm,
          }
        }
      }
    );
  }
});

export const pipelineUIReducer = pipelineUISlice.reducer;
